import { P00039DataRxTxIndex } from '../../../P00039Sync';
import { P00032 } from '../../../P00032';
import { P00030 } from '../../../P00030';
import {
  getPoolMasterClass,
  getPoolProduct,
} from '../../../../../ECoSystemsHelper';
import { IProduct } from '../../../../IProduct';
import { Pool } from '../../../../../../../apis/pool.api';

export function P0003601FiltrationMiseEnOeuvreInit(
  pool: Pool,
  productClass: IProduct,
  editValue: any,
) {
  const master = getPoolMasterClass(pool);
  const product = getPoolProduct(pool, productClass);
  const produitP00032 = master?.hasProduct(pool, new P00032()) ?? 0;
  const produitP00030 = master?.hasProduct(pool, new P00030()) ?? 0;

  let force = false;

  const capteurTemperatureHorsGel = (val: number) => {
    if (produitP00032 == 0 && produitP00030 == 0) return 0;
    if (produitP00032 > 0 && produitP00030 == 0) return 1;
    if (produitP00032 == 0 && produitP00030 > 0) return 2;
    if (val == 0 && produitP00032 > 0 && produitP00030 > 0) return 1;

    return val;
  };

  const fvsICapteurTemperatureReferenceHorsGel =
    product!.data.fvsICapteurTemperatureReferenceHorsGel;
  const newFvsICapteurTemperatureReferenceHorsGel = capteurTemperatureHorsGel(
    fvsICapteurTemperatureReferenceHorsGel,
  );

  if (
    fvsICapteurTemperatureReferenceHorsGel !=
    newFvsICapteurTemperatureReferenceHorsGel
  ) {
    editValue(
      P00039DataRxTxIndex.FiltrationVS_Installation,
      'fvsICapteurTemperatureReferenceHorsGel',
      newFvsICapteurTemperatureReferenceHorsGel,
      null,
      productClass,
    );
    force = true;

    if (newFvsICapteurTemperatureReferenceHorsGel == 1) {
      editValue(
        P00039DataRxTxIndex.FiltrationVS_Parametrage4,
        'fvsPSeuilTemperatureHorsGel',
        3,
        null,
        productClass,
      );
    } else if (newFvsICapteurTemperatureReferenceHorsGel == 2) {
      editValue(
        P00039DataRxTxIndex.FiltrationVS_Parametrage4,
        'fvsPSeuilTemperatureHorsGel',
        0,
        null,
        productClass,
      );
    }
  }

  editValue(
    P00039DataRxTxIndex.FiltrationVS_Installation,
    'fvsICapteurTemperatureReference2424',
    1,
    null,
    productClass,
  );

  return force;
}
